import { useQuery } from '@tanstack/react-query';
import { getCourses } from './api'; // Importation de la fonction asynchrone
import { Programme } from './type';

/**
 * Hook pour récupérer le programme des cours pour une date donnée.
 * @param {string} date - La date pour laquelle récupérer le programme.
 * @returns {object} - Résultat de la requête React Query.
 */
const useGetCourses = (date: string) => {
  return useQuery<Programme, Error>({
    queryKey: ['courses', date], // Clé unique pour cette requête
    queryFn: () => getCourses(date), // Fonction de récupération
    enabled: !!date && date.length > 0, // Exécute uniquement si une date est fournie
    staleTime: 1000 * 60 * 10, // Les données sont fraîches pendant 10 minutes
    retry: 2, // Réessaie jusqu'à 2 fois en cas d'échec
  });
};

export default useGetCourses;
